<p-tabView
  [styleClass]="config?.styleClass"
  [activeIndex]="config?.activeIndex ?? 0"
  [controlClose]="config?.controlClose"
  [scrollable]="config?.scrollable"
  (onChange)="onChange($event)"
  (onClose)="onClose($event)"
  (activeIndexChange)="onActiveIndexChange($event)"
>
  <p-tabPanel
    *ngFor="let tab of getTabs()"
    [header]="tab.title"
    [closable]="tab.closable"
    [disabled]="tab.disabled!"
    [selected]="tab.selected!"
    [headerStyleClass]="tab.headerStyleClass"
    [leftIcon]="tab.leftIcon!"
    [rightIcon]="tab.rightIcon"
    [tooltip]="tab.tooltip"
    [tooltipPosition]="tab.tooltipPosition!"
    [tooltipPositionStyle]="tab.tooltipPositionStyle"
    [tooltipStyleClass]="tab.tooltipStyleClass"

  >
  <!-- [pStyleClass]="tab.styleClass ?? 'panel_{{tab.title}}'"
       [enterActiveClass]="tab.enterActiveClass"
    [leaveActiveClass]="tab.leaveActiveClass"
  -->
    <ng-container *ngTemplateOutlet="tab.content!"></ng-container>
  </p-tabPanel>
</p-tabView>
